module.exports = __webpack_public_path__ + "img/dial-med-low.362d0a63.svg";